@if (deliveryJobQuery.isLoading() && !deliveryJobQuery.data()) {
<ngx-skeleton-loader appearance="line" count="5"></ngx-skeleton-loader>
}
@if (deliveryJobQuery.isError()) {
<p>Error: {{ deliveryJobQuery.error() }}</p>
}
@if (deliveryJobQuery.data()) {
<div class="w-full flex flex-col justify-start items-stretch">
  <div class="flex flex-col justify-start items-stretch">
    <div class="flex flex-row justify-between items-center gap-x-4">
      <div class="flex flex-row basis-full justify-between items-start gap-x-4">
        <h1 class="flex-grow-0 flex-shrink-0">Job Details</h1>
        <delivery-status [delivery]="deliveryStatusData()"></delivery-status>
      </div>
      <button (click)="close.emit()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="flex flex-row justify-between w-full items-center gap-x-4">
      <div class="flex flex-row justify-start items-center gap-x-4 mt-2 md:mt-0">
        <button (click)="print(false)" mat-icon-button>
          <mat-icon>print</mat-icon>
        </button>

        <button (click)="print(true)" mat-icon-button>
          <mat-icon>download</mat-icon>
        </button>
      </div>

      <div class="self-end">
        <app-assigned-to [(ngModel)]="deliveryJobQuery.data().allocated_to"></app-assigned-to>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
      <app-key-value-pair name="Type" [value]="deliveryJobQuery.data().type | titlecase"></app-key-value-pair>

      <app-key-value-pair name="Customer"
        [value]="deliveryJobQuery.data().deliverable.customer | customerName"></app-key-value-pair>

      <app-document-contact [contactId]="deliveryJobQuery.data().deliverable.contact_id"
        [customerId]="deliveryJobQuery.data().deliverable.customer_id" [readonly]="true"></app-document-contact>

      <p>
        <strong>Source: </strong>
        <ng-container *ngIf="deliveryJobQuery.data().deliverable_type === 'booking'">
          <a [routerLink]="[
                '/bookings/view',
                deliveryJobQuery.data().deliverable.id
              ]">Booking {{ deliveryJobQuery.data().deliverable.id }}</a>
        </ng-container>
        <ng-container *ngIf="deliveryJobQuery.data().deliverable_type === 'docket'">
          <a [routerLink]="['/docket', deliveryJobQuery.data().deliverable.id]">Hire Contract {{
            deliveryJobQuery.data().deliverable.id }}</a>
        </ng-container>
      </p>
      <app-key-value-pair name="Due" [value]="deliveryJobQuery.data().due | amDateFormat: dateTimeFormat">
      </app-key-value-pair>
    </div>

    <div class="flex flex-row justify-start items-center gap-x-6">
      <app-key-value-pair [name]="
            deliveryJobQuery.data().type === 'collection'
              ? 'Collect From'
              : 'Deliver To'
          " [value]="deliveryJobQuery.data().location | newLine"></app-key-value-pair>
      <app-google-maps-link [address]="deliveryJobQuery.data().location"
        [placeId]="deliveryJobQuery.data().google_place_id" />
    </div>

    @if (deliveryJobQuery.data().notes) {
    <app-key-value-pair name="Notes" [value]="deliveryJobQuery.data().notes | newLine"
      notSetMessage=""></app-key-value-pair>
    }

    <app-delivery-items-list [delivery]="deliveryJobQuery.data()"
      (completed)="deliveryJobQuery.refetch()"></app-delivery-items-list>
    <iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>
  </div>
</div>
}